<template>
  <div class="ml10">
    <p v-html="changeTag(data.text)" class="bold" />
    <p v-html="changeTag(data.translate)" class="mb10" />
  </div>
</template>

<script>
import common from '@/mixin/common';

export default {
  name: 'phraseResult',
  props: {
    data: Object
  },
  mixins: [
    common
  ]
};
</script>

<style lang="scss">
@import 'src/assets/style/modal';
</style>



// WEBPACK FOOTER //
// PhraseResult.vue?cb2cb840